// extracted by mini-css-extract-plugin
export default {"loaderScreen":"LoaderScreen_loaderScreen__3cHYV","dark":"LoaderScreen_dark__xgFfm"};